import now from 'performance-now';
import { handleAction } from 'uix/actions';
import { get } from 'ldash';
import { setLogdata, clearHistories, hotReload } from './actions';
import log from 'uix/logging';
export const data = [
    handleAction('SET_FILTER_DATA', // if getLogdata filter output available, append to logdata
    (data, action)=>{
        const orgLogdata = get(data, 'logdata', '');
        const logdata = get(action, 'payload.filterData.Logframe.getLogdata.data.logdata[$text]', null);
        if (logdata) {
            return {
                ...data,
                logdata: orgLogdata.concat(logdata)
            };
        }
        return data;
    }, {
        logdata: ''
    }),
    handleAction('INTERPRETER_OUTPUT', (data, action)=>{
        let interpreterOutput = data.interpreterOutput || [
            'Good morning Dave! Armament at your disposal:'
        ];
        if (action.payload.output == 'CLEAR') {
            interpreterOutput = [];
        } else {
            interpreterOutput = [
                ...interpreterOutput,
                action.payload.output
            ];
        }
        return {
            ...data,
            interpreterOutput
        };
    })
];
export const meta = [
    handleAction('PPRINT', (meta, action)=>{
        return {
            ...meta,
            pprint: action.payload.__CLEAR__ ? null : action.payload
        };
    }, {
        pprint: null
    }),
    handleAction('API_CALL_START', (debug, { payload, meta })=>{
        if (payload.path == '/auth/info') {
            // do not track this one
            return debug;
        }
        return {
            ...debug,
            apiCalls: [
                ...debug.apiCalls,
                {
                    ...payload,
                    apiCallId: meta.apiCallId
                }
            ]
        };
    }, {
        apiCalls: []
    }),
    handleAction('API_CALL_END', (debug, { payload })=>{
        let apiCalls = debug.apiCalls.map((e)=>e.apiCallId === payload.apiCallId ? {
                ...e,
                ...payload,
                duration: Math.floor(now() - e.ts)
            } : e).slice(-50);
        return {
            ...debug,
            apiCalls
        };
    })
];
export const debug = [
    (debug, action)=>{
        if (debug == undefined) {
            return {
                lastActions: [],
                numActions: 0
            } // initial state
            ;
        }
        //~ log(debug, action)
        return {
            ...debug,
            lastActions: [
                ...debug.lastActions || [],
                action.type
            ].slice(-500),
            numActions: debug.numActions + 1
        };
    },
    handleAction('SET_DEBUG', (debug, action)=>{
        return {
            ...debug,
            on: action.payload.on
        };
    }, // auto on for users with debug group
    {
        on: undefined
    }),
    handleAction('SET_DEBUG_DATA', (debug, action)=>({
            ...debug,
            ...action.payload
        })),
    handleAction(hotReload, (debug, { payload })=>{
        let { status, gen } = debug.hmr;
        if (status == payload.status) {
            // no change
            return debug;
        }
        if (payload.status == 'idle') {
            // entering idle again
            gen += 1;
        }
        return {
            ...debug,
            hmr: {
                status: payload.status,
                gen
            }
        };
    }, {
        hmr: {
            status: 'idle',
            gen: 0
        }
    }),
    handleAction('TEST_ERROR_MUTATE', (debug, action)=>{
        debug.hmr.gen = -1;
    }),
    handleAction('TEST_ERROR_THROW', (debug, action)=>{
        throw Error('a reducer has crashed');
    }),
    handleAction('BENCHMARK', (debug, { payload })=>{
        return {
            ...debug,
            bench_count: payload
        };
    })
];
